export function useGroupOperations(groups, setGroups, flashcards, setFlashcards, activeGroupId, setActiveGroupId) {
  const createGroup = (name, topic, difficulty) => {
    const newGroup = {
      id: Date.now().toString(),
      name,
      topic,
      difficulty,
      createdAt: new Date().toISOString(),
      cardIds: []
    };
    setGroups(prev => [...prev, newGroup]);
    return newGroup.id;
  };

  const renameGroup = (groupId, updates) => {
    setGroups(prev =>
      prev.map(group =>
        group.id === groupId
          ? {
              ...group,
              name: updates.name ?? group.name,
              topic: updates.topic ?? group.topic,
              difficulty: updates.difficulty ?? group.difficulty,
            }
          : group
      )
    );
  };

  const duplicateGroup = (groupId, overrides = {}) => {
    const sourceGroup = groups.find(group => group.id === groupId);
    if (!sourceGroup) return null;

    const sourceCards = flashcards.filter(card => card.groupId === groupId);
    const newGroupId = `${Date.now()}-${Math.random().toString(16).slice(2, 8)}`;
    const now = new Date().toISOString();

    const duplicatedCards = sourceCards.map(card => ({
      ...card,
      id: Date.now() + Math.random(),
      groupId: newGroupId,
      createdAt: now,
      reviewed: false,
      lastReviewed: null,
    }));

    const newGroup = {
      ...sourceGroup,
      id: newGroupId,
      name: overrides.name || `${sourceGroup.name || sourceGroup.topic} Copy`,
      topic: overrides.topic || `${sourceGroup.topic} Copy`,
      difficulty: overrides.difficulty || sourceGroup.difficulty,
      createdAt: now,
      cardIds: duplicatedCards.map(card => card.id),
    };

    setFlashcards(prev => [...prev, ...duplicatedCards]);
    setGroups(prev => [...prev, newGroup]);
    return newGroupId;
  };

  const deleteGroup = (groupId) => {
    setFlashcards(prev => 
      prev.map(card => 
        card.groupId === groupId ? { ...card, groupId: null } : card
      )
    );
    setGroups(prev => prev.filter(group => group.id !== groupId));
    if (activeGroupId === groupId) {
      setActiveGroupId(null);
    }
  };

  const sortedGroups = [...groups].sort((a, b) => {
    const topicCompare = a.topic.localeCompare(b.topic);
    if (topicCompare !== 0) return topicCompare;

    return a.difficulty.localeCompare(b.difficulty);
  });

  return {
    createGroup,
    renameGroup,
    duplicateGroup,
    deleteGroup,
    sortedGroups
  };
}
